module.exports = __webpack_public_path__ + "static/media/douka-icon.25df9f08.svg";